/** 404：未匹配路由。 */
import { Link } from 'react-router-dom';
import { Icon } from '../components/icons';
import { Button } from '../components/ui';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
      <Icon name="search" className="h-12 w-12 text-slate-300 dark:text-slate-600" />
      <h1 className="text-2xl font-bold text-slate-800 dark:text-slate-100">页面不存在</h1>
      <p className="text-sm text-slate-500 dark:text-slate-400">你访问的地址没有对应的页面</p>
      <Link to="/">
        <Button>返回仪表盘</Button>
      </Link>
    </div>
  );
}
